import qs from "qs";
import axios from "axios";
import { API_URL, URL } from "../../../../constants/Constants";
import { notify } from "../../../ui/notify";

/**
 * Obtiene datos completos de PO y MO
 * @param {string} type - Tipo de pantalla
 * @param {string} typeConnect - Tipo de conexión
 * @param {number} currentScreenId - ID de la pantalla actual
 * @returns {Promise<Array|false>} Datos de PO y MO o false si no se encuentran
 */
export const getFullPoAndMo = async (type, typeConnect, currentScreenId) => {
  const queryData = {
    screen: type,
    action: typeConnect,
    query_type: currentScreenId,
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene lista completa de grupos
 * @param {string} type - Tipo de consulta (mantenido por compatibilidad, no se usa)
 * @param {string} typeConnect - Tipo de conexión (mantenido por compatibilidad, no se usa)
 * @returns {Promise<Array|false>} Lista de grupos o false si no se encuentran
 */
export const getListFullGroup = async (type, typeConnect) => {
  const queryData = {
    screen: "foundry",
    action: "query",
    requestType: "fullGroupList",
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene lista completa de grupos terminados
 * @param {string} type - Tipo de consulta (mantenido por compatibilidad, no se usa)
 * @param {string} typeConnect - Tipo de conexión (mantenido por compatibilidad, no se usa)
 * @returns {Promise<Array|false>} Lista de grupos terminados o false si no se encuentran
 */
export const getListFullFinishGroup = async (type, typeConnect) => {
  const queryData = {
    screen: "completed_foundry",
    action: "query",
    requestType: "fullGroupFinishList",
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Crea una nueva agrupación
 * @param {string} name - Nombre de la agrupación
 * @param {string} type - Tipo de consulta (mantenido por compatibilidad, no se usa)
 * @param {string} selectedMetal - Metal seleccionado (opcional)
 * @param {string} selectedAgrupaciones - Agrupaciones seleccionadas
 * @param {string} typeConnect - Tipo de conexión (mantenido por compatibilidad, no se usa)
 * @param {string} date - Fecha (formato: "d/m/Y H:i:s")
 * @returns {Promise<Object|false>} Datos de la nueva agrupación o false si hay error
 */
export const createNewGrouping = async (
  name,
  type,
  selectedMetal,
  selectedAgrupaciones,
  typeConnect,
  date
) => {
  const queryData = {
    screen: "foundry",
    action: "insert",
    name: name,
    selectedAgrupaciones: selectedAgrupaciones,
    date: date,
  };

  // Agregar selectedMetal solo si se proporciona
  if (selectedMetal) {
    queryData.selectedMetal = selectedMetal;
  }

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Elimina un elemento de un grupo
 * @param {string} type - Tipo de consulta (mantenido por compatibilidad, no se usa)
 * @param {string} typeConnect - Tipo de conexión (mantenido por compatibilidad, no se usa)
 * @param {string} mo - Manufacturing Order
 * @param {string} aleacion - Aleación
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const deleteElementFromGroup = async (type, typeConnect, mo, aleacion) => {
  const queryData = {
    screen: "foundry",
    action: "delete",
    requestType: "deleteElementFromGroup",
    mo: mo,
    aleacion: aleacion,
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Elimina una MO de la fundición
 * @param {string} type - Tipo de consulta (mantenido por compatibilidad, no se usa)
 * @param {string} typeConnect - Tipo de conexión (mantenido por compatibilidad, no se usa)
 * @param {string} mo - Manufacturing Order
 * @param {string} aleacion - Aleación
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const deleteMOFromFoundry = async (type, typeConnect, mo, aleacion) => {
  const queryData = {
    screen: "foundry",
    action: "delete",
    requestType: "deleteMoFromFoundry",
    mo: mo,
    aleacion: aleacion,
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Inserta un nuevo metal a un grupo
 * @param {string} type - Tipo de consulta (mantenido por compatibilidad, no se usa)
 * @param {string} typeConnect - Tipo de conexión (mantenido por compatibilidad, no se usa)
 * @param {string} selectedAgrupacion - Agrupación seleccionada
 * @param {Object} newAddOption - Nueva opción a agregar (debe incluir empresa, po, mo, aleacion, gramos)
 * @param {string} fechaActual - Fecha actual (formato: "YYYY-MM-DD HH:mm:ss")
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const insertNewMetalToGroup = async (
  type,
  typeConnect,
  selectedAgrupacion,
  newAddOption,
  fechaActual = null
) => {
  const queryData = {
    screen: "foundry",
    action: "insert",
    requestType: "insertNewLineInGroup",
    selectedAgrupacion: selectedAgrupacion,
    newAddOption: newAddOption,
    fechaActual: fechaActual || new Date().toISOString().slice(0, 19).replace('T', ' '),
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Actualiza el estado de finalización de una agrupación
 * @param {string} type - Tipo de consulta (mantenido por compatibilidad, no se usa)
 * @param {string} typeConnect - Tipo de conexión (mantenido por compatibilidad, no se usa)
 * @param {string} selectedAgrupacion - Agrupación seleccionada
 * @param {string} inputValue - Valor de entrada (número de lote)
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const UpdatefinishAgrupacion = async (
  type,
  typeConnect,
  selectedAgrupacion,
  inputValue
) => {
  const queryData = {
    screen: "foundry",
    action: "update",
    requestType: "finishAgrupación",
    selectedAgrupacion: selectedAgrupacion,
    inputValue: inputValue,
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene MO para trabajo múltiple
 * @param {string} type - Tipo de pantalla
 * @param {string} typeConnect - Tipo de conexión
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} scannedCodes - Códigos escaneados
 * @returns {Promise<Array|false>} Datos de MO para trabajo múltiple o false si no se encuentran
 */
export const getMOForMultipleWork = async (
  type,
  typeConnect,
  currentScreenId,
  scannedCodes
) => {
  const queryData = {
    screen: type,
    action: typeConnect,
    query_type: currentScreenId,
    codes: scannedCodes,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Resetea una MO de la fundición
 * @param {number} currentScreenId - ID de la pantalla actual (mantenido por compatibilidad, no se usa)
 * @param {string} type - Tipo de operación (mantenido por compatibilidad, no se usa)
 * @param {string} mo - Manufacturing Order
 * @returns {Promise<boolean>} true si se reseteó correctamente, false en caso contrario
 */
export const resetMOFoundry = async (currentScreenId, type, mo) => {
  const queryData = {
    screen: "foundry",
    action: "update",
    requestType: "resetMoForFoundry",
    mo: mo,
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      notify.success("La MO ha sido restaurada");
      return true;
    } else {
      notify.error("Error al restaurar la MO");
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene datos completos de pieza de fundición
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} typeConnect - Tipo de conexión
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const fullDataFundicionPiece = async (currentScreenId, typeConnect) => {
  const queryData = {
    query_type: currentScreenId,
    action: typeConnect,
  };
  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};
